<template>
  <div>
    <div class="title">{{ object.name }}</div>
    <div style="padding: 0 12px; margin-bottom: 60px">
      <div class="desc">
        <span class="fbr">发布时间：{{ object.createTime }}</span>
      </div>
      <div class="video-p">
        <video class="video" :src="object.video" controls></video>
      </div>
      <div class="h5-html" style="font-size: 14px">{{ object.videoIntroduction }}</div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      params: this.$route.query,
      object: {},
    }
  },
  created() {},
  mounted() {
    console.log('详情', this.$store.state.fzjzView)
    this.object = this.$store.state.fzjzView
    // this.getData()
  },
  methods: {
    getData() {
      // let openId = this.$store.getters.openId;
      // let params = {openId:openId,id:this.params.id}
      // getAction('/system/sysnotice/query/by/id',params)
      // .then((res) => {
      //    [this.html, this.richImages] = addRandomAndGetPreviewImageUrlsFromRichText(this.object.nr)
      // })
    },
  },
}
</script>

<style lang="less" scoped>
/*说明*/
.title {
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.desc {
  color: #696969;
  margin-bottom: 12px;
  font-size: 14px;
}

.fbr {
  margin-right: 8px;
}

.time {
  margin-left: 8px;
}

.content {
  color: #303133;
  text-indent: 2em;
  line-height: 22px;
}

.bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.h5-html img {
  width: 100%;
}

.video-p {
  width: 100%;
  background: #000;
  height: 240px;
  margin-bottom: 8px;
  .video {
    width: 100%;
    height: 100%;
  }
}
</style>
